// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3RYqJ","bigColWidth":"Table_bigColWidth__30KPU","biggerColWidth":"Table_biggerColWidth__2uT-1","row":"Table_row__2bNNE","col":"Table_col__TR7mP"};